export { default as ArchiveBoxXMarkOutlineIcon } from './ArchiveBoxXMarkOutlineIcon';
